/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const HoursType = {
    NUMBER_0: 0,
    NUMBER_10: 10,
    NUMBER_15: 15,
    NUMBER_20: 20,
    NUMBER_25: 25,
    NUMBER_30: 30,
    NUMBER_40: 40,
    NUMBER_45: 45,
    NUMBER_50: 50,
    NUMBER_55: 55,
    NUMBER_60: 60,
    NUMBER_70: 70,
    NUMBER_99: 99
} as const;

export type HoursType = typeof HoursType[keyof typeof HoursType];



